import React from 'react';
import { string, bool, node, func, object} from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";
import portalTheme from "../../../themes/portalTheme";

import cx from 'classnames';
import s from '../FormElement.css';


const PortalDatePicker = ({
  className, description, disabled, errorText,
  id, label, name, onChange, required, value, onBlur,
}) => {
  return (
    <div className={cx(s.component, className, {[`${s.disabled}`]: disabled})}>
      <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
        <DatePicker
          className={s.datePicker}
          disabled={disabled}
          errorText={errorText}
          errorStyle={{color:'#B2120B'}}
          id={id}
          floatingLabelText={label}
          floatingLabelStyle={{color:'#222222'}}
          name={name}
          onChange={(isAlwaysNull, value) => { if (onChange) onChange(value.toString()) } }
          value={value}
          onBlur={onBlur}
        />
      </MuiThemeProvider>
      {description &&
        <label className={s.description}>{description}</label>
      }
    </div>
  );
};

PortalDatePicker.propTypes = {
  className: string,
  description: string,
  disabled: bool,
  errorText: node,
  id: string.isRequired,
  label: node,
  name: string,
  onChange: func,
  required: bool,
  value: object,
  onBlur: func,
};

export default PortalDatePicker;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalDatePicker/PortalDatePicker.js